import { DoNotTow } from "types";
import { getRequestHeaders, handleRes, logError } from "utils";

interface CreateDNTParams {
  tenantID: string | number | undefined;
  body: string; //  DoNotTow as JSON string
}
export const createDNT = ({
  tenantID,
  body,
}: CreateDNTParams): Promise<Response> => {
  return fetch(`${window.PROPERTY_BASE_URL}/tenant/${tenantID}/doNotTow`, {
    method: "POST",
    ...getRequestHeaders(),
    body,
  });
};

interface GetPropertyDNTListParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
}
export const getPropertyDNTList = ({
  tenantID,
  propertyID,
}: GetPropertyDNTListParams): Promise<DoNotTow[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/doNotTow`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<DoNotTow[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

interface GetPropertyGroupDNTListParams {
  tenantID: string | number | undefined;
  groupID: string | number | undefined;
}
export const getPropertyGroupDNTList = ({
  tenantID,
  groupID,
}: GetPropertyGroupDNTListParams): Promise<DoNotTow[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/doNotTow`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<DoNotTow[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

export const getTenantDNTList = (
  tenantID: number | string | undefined,
): Promise<DoNotTow[]> => {
  return fetch(`${window.PROPERTY_BASE_URL}/tenant/${tenantID}/doNotTow`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<DoNotTow[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

interface UpdateDNTParams {
  tenantID: string | number | undefined;
  dntID: string | number | undefined;
  body: string; //  DoNotTow as JSON string
}
export const updateDNT = ({
  tenantID,
  dntID,
  body,
}: UpdateDNTParams): Promise<Response> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/doNotTow/${dntID}`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};
